import * as Cookies from "js-cookie";
import { ModalManager, RemodalAdapter, ModalPriority } from "./modal_manager";
import "remodal/dist/remodal.css";
import "remodal/dist/remodal-default-theme.css";
import "remodal";

$(function() {
  //▼ 歯科医療従事者確認モーダルの表示
  const $dentalProfessional = $("[data-remodal-id=doctor-confirm]");
  if ($dentalProfessional.length > 0) {
    const dentalProfessionalConfirmModal = $dentalProfessional.remodal();
    const isDentalProfessionalUnconfirmed = (Cookies.get("yes_doctor") !== "yes");

    if (isDentalProfessionalUnconfirmed) {
      ModalManager.enqueue(
        new RemodalAdapter(
          dentalProfessionalConfirmModal,
          ModalPriority.DENTAL_PROFESSIONAL_CONFIRM
        )
      );
    }

    $dentalProfessional.on("confirmation", function() {
      Cookies.set("yes_doctor", "yes", { expires: 31 });
    });

    $dentalProfessional.on("cancellation", function() {
      window.location.href =
        "https://doctorbook.jp/?utm_source=academy&utm_medium=ownedmedia";
    });
  }

  //▼ Facebookログインモーダルの表示
  const $facebookLogin = $("[data-remodal-id=facebook-login]");
  if ($facebookLogin.length > 0) {
    const facebookLoginModal = $facebookLogin.remodal();

    $(document).on("click", "#facebook-login", function(e) {
      e.preventDefault();
      ModalManager.enqueue(
        new RemodalAdapter(facebookLoginModal, ModalPriority.FACEBOOK_LOGIN)
      );
    });

    $facebookLogin.on("confirmation", function() {
      window.location.href = "/auth/facebook";
    });

    $facebookLogin.on("cancellation", function() {
      facebookLoginModal.close();
    });
  }

  //▼ GMOカード入力モーダルの表示
  const $gmoModal = $("[data-remodal-id=gmo-modal]");
  if ($gmoModal.length > 0) {
    const gmoModal = $gmoModal.remodal();

    $(document).on("click", "#gmo_modal_open_btn", function() {
      ModalManager.enqueue(
        new RemodalAdapter(gmoModal, ModalPriority.GMO_CARD_FORM)
      );
    });

    // GMOモーダルを閉じるグローバル関数を定義
    window.closeGmoModal = function() {
      gmoModal.close();
    };

    // GMOモーダルのキャンセル時にバリデーションをクリア
    $gmoModal.on("cancellation", function() {
      clearGmoValidation();
    });
  }

  //▼ J&Jモーダルの表示 (TODO: 廃止)
  const $jjOptions = $("[data-remodal-id=JJ-options]");
  if ($jjOptions.length > 0) {
    const JJConfirmModal = $jjOptions.remodal();
    let isShowAgain = false;

    // 指定のページ(依頼のあった特定企業動画とsurveys)ではJ&Jモーダルを表示しない
    const path = window.location.pathname;
    const isExcludedPage = path.startsWith('/movies/1007954') || path.startsWith('/surveys');

    const isJJNotAccepted = (Cookies.get("J&J") !== "accept")
    const isDentalProfessionalConfirmed = (Cookies.get("yes_doctor") === "yes");

    if (isJJNotAccepted && isDentalProfessionalConfirmed && !isExcludedPage) {
      ModalManager.enqueue(
        new RemodalAdapter(JJConfirmModal, ModalPriority.JOHNSON_AND_JOHNSON)
      );
    }

    $(".JJ_cancel_option").on("click", () => {
      JJConfirmModal.close();
      Cookies.set("J&J", "accept");
      isShowAgain = true;
    });

    $(".JJ_option").on("click", () => {
      $(".remodal-overlay, .JJ_cancel_option, .JJ_option").css("display", "none");
      $(".JJ_modal").css("visibility", "hidden");
      JJConfirmModal.close();
      Cookies.set("J&J", "accept");
      isShowAgain = true;
    });

    // 他のモーダルの閉鎖イベントに連動するため、ここはdocumentに対する委譲のまま維持する
    $(document).on("closed", "[data-remodal-id=doctor-confirm]", function(e) {
      const isJJNotAccepted = (Cookies.get("J&J") !== "accept");
      const isNotCancellation = (e.reason !== "cancellation");

      if (isJJNotAccepted && isNotCancellation) {
        ModalManager.enqueue(
          new RemodalAdapter(
            JJConfirmModal,
            ModalPriority.JOHNSON_AND_JOHNSON
          )
        );
      }
    });

    $(".JJ_close_icon").on("click", () => {
      Cookies.set("J&J", "accept", { expires: 14 });
      isShowAgain = true;
      JJConfirmModal.close();
    });

    $jjOptions.on("closed", function() {
      if (!isShowAgain) Cookies.set("J&J", "accept", { expires: 14 });
    });
  }
});
